import React from 'react'
import { motion } from "framer-motion"

const Hero: React.FC = () => {
    const fadeInVariant = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
    };

    const slideVariants = {
        hidden: (direction: number) => ({ y: direction * 50, opacity: 0 }),
        visible: { y: 0, opacity: 1, transition: { duration: 0.5 } },
        exit: (direction: number) => ({ y: direction * 50, opacity: 0, transition: { duration: 0.5 } }),
    };

    return (
        <main className='tw-pt-20 tw-h-lvh tw-w-lvw tw-flex tw-flex-col tw-items-center tw-z-10 tw-relative tw-justify-center'>
            <img data-aos="fade-left"
                src="/ContactUs/logo.svg"
                alt=""
                className="tw-absolute -tw-z-10 lg:tw-right-0 lg:tw-top-[10vh] tw-drop-shadow-[-10px_0_400px_#00ddff] "
            />


            <h3
                data-aos="fade-up"
                className='tw-text-lg'>Contact Us</h3>
            <h1 data-aos="fade-up"
                className='lg:tw-text-8xl tw-text-6xl tw-font-semibold'>Let's talk.</h1>
        </main>
    )
}

export default Hero